import {Component, OnInit} from '@angular/core';
import {
  Event,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterEvent
} from "@angular/router";
import {filter} from 'rxjs';
import {ProfileService} from 'src/app/auth_profile/services/profile.service';
import {NativeServiceApiProvider} from 'src/app/services/native-api-provider.service';
import {ThemeService} from 'src/app/services/theme.service';
import {LangService} from "../../services/lang.service";

@Component({
    selector: 'app-unaffiliated-dashboard-layout',
    templateUrl: './unaffiliated-dashboard-layout.component.html',
    styleUrls: ['./unaffiliated-dashboard-layout.component.scss'],
    standalone: false
})
export class UnaffiliatedDashboardLayoutComponent implements OnInit {
  activePath: string;
  activeSegments: string[];
  theme: string;
  profilePhoto: string;

  constructor(
    router: Router,
    private profileService: ProfileService,
    public themeService: ThemeService,
    public provider: NativeServiceApiProvider,
    private langService: LangService,
  ) {
    router.events.pipe(
      filter((e: Event): e is NavigationStart | NavigationEnd | NavigationCancel | NavigationError => e instanceof NavigationStart ||
                   e instanceof NavigationEnd ||
                   e instanceof NavigationCancel ||
                   e instanceof NavigationError)
      ).subscribe((e: RouterEvent) => {
        this.activePath = e['urlAfterRedirects'];
        this.activePath
          ? (this.activeSegments = this.activePath.split('/'))
          : '';
      });

    this.langService.initialize()
  }

  ngOnInit(): void {
    this.loadProfilePhoto();
    this.themeService.getTheme().subscribe((theme) => (this.theme = theme));
  }

  private loadProfilePhoto() {
    this.profileService.getSelfPhoto().subscribe((photo) => {
      this.profilePhoto = photo?.publicAccessUrl || null;
    });
  }
}
